import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from '@app/app-routing.module';
import { ServiceProxyModule } from '@shared/service-proxies/service-proxy.module';
import { UtilsModule } from '@shared/utils/utils.module';
import { IMaskModule } from 'angular-imask';
import { FileUploadModule } from 'ng2-file-upload';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { PaginatorModule } from 'primeng/paginator';
import { ProgressBarModule } from 'primeng/progressbar';
import { TableModule } from 'primeng/table';
import { AppCommonModule } from './common/app-common.module';
import { MazarsCommonModule } from '@app/modules/mazars-common/mazars-common.module';
import { ThemesLayoutBaseComponent } from './layout/themes/themes-layout-base.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { NotificationStore } from './layout/notifications/store/notification.store';
const imports = [
    CommonModule,
    FormsModule,
    ModalModule,
    TabsModule,
    BsDropdownModule,
    PopoverModule,
    BsDatepickerModule,
    AppCommonModule,
    MazarsCommonModule,
    FileUploadModule,
    AppRoutingModule,
    UtilsModule,
    ServiceProxyModule,
    TableModule,
    PaginatorModule,
    ProgressBarModule,
    IMaskModule,
    ImageCropperComponent,
    AutoCompleteModule,
    NgxSpinnerModule,
    NgScrollbarModule
];

@NgModule({
    imports: [...imports, ThemesLayoutBaseComponent],
    exports: [...imports],
    providers: [NotificationStore]
})
export class AppSharedModule { }
